<template>
  <v-main>
    <v-container>
      <v-card class="mx-auto mt-n8" flat max-width="1080">
        <v-row>
          <!-- INDICAÇÃO APROVADA -->
          <v-col class="mt-n1" cols="12" md="12">
            <!-- <v-parallax src="../assets/indicacao-aceita.png" ></v-parallax> -->
            <v-img
              src="../assets/indicacao-aceita.png"
              aspect-ratio="2"
              contain
            ></v-img>
            <div
              class="ma-8"
              style="text-align: justify; color: #003ea6; font-weight: 500"
            >
              <div>
                <p>Agradecemos pelo envio das informações e documentações.</p>
                <p>
                  A Odontoprev analisará as documentações e, estando em
                  conformidade, você receberá o Contrato de Credenciamento para
                  assinatura digital pela plataforma Docusign.
                </p>
                <p>
                  Processo inovador e digital, sem burocracia e separação de
                  documentos físicos, após a assinatura eletrônica
                  credenciaremos com agilidade e você fará parte da maior rede
                  credenciada da América Latina.
                </p>
                <p>
                  Acesse a nossa página e conheça os benefícios que oferecemos
                  aos credenciados.
                </p>
                <p>
                  Temos um canal exclusivo para esclarecer dúvidas sobre o
                  processo de credenciamento.
                </p>
                <p>
                  Clique aqui: <a>https://www.odontoprev.com.br/dentista/</a>
                </p>
              </div>
              <div class="ma-8" style="color: #003ea6; font-weight: bold">
                <p>Cordialmente,<br />Equipe de Credenciamento Odontoprev</p>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-8" cols="12" md="12">
            <v-btn color="primary" class="mr-4" @click="voltar"
              ><i class="fas fa-arrow-circle-left"></i> &nbsp;Voltar</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
export default {
  methods: {
    voltar() {
      this.$router.push('/');
    },
  },
  created: function () {
    if (Object.keys(this.$route.params).length === 0) {
      this.$router.push('/');
    }
  },
};
</script>
